// contexts/SettingsContext.tsx
import React, { createContext, useContext, useEffect, useState } from 'react';
import { Settings, SettingsContextType } from '../utils/types';


const SettingsContext = createContext<SettingsContextType | undefined>(undefined);

export const SettingsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [settings, setSettings] = useState<Settings | null>(null);

    useEffect(() => {
        const storedSettings = localStorage.getItem('settings');
        if (storedSettings) {
            const parsedSettings = JSON.parse(storedSettings);
            setSettings(parsedSettings[0][0]); // Use the first element if stored as an array
        }

        // console.table(JSON.stringify(storedSettings));
        // console.table(storedSettings);
    }, []);

    return (
        <SettingsContext.Provider value={{ settings, setSettings }}>
            {children}
        </SettingsContext.Provider>
    );
};

export const useSettings = (): SettingsContextType => {
    const context = useContext(SettingsContext);
    if (!context) {
        throw new Error('useSettings must be used within a SettingsProvider');
    }
    return context;
};
